"use client";

import { createContext, useContext, useEffect, useState } from "react";
import { useInView } from "framer-motion";

const Sequence = createContext({ phase: "idle", setPhase: () => {} });
export default function PortfolioSequence({ children }) {
  const [phase, setPhase] = useState("idle");
  return <Sequence.Provider value={{ phase, setPhase }}>{children}</Sequence.Provider>;
}
export const usePortfolioSequence = () => useContext(Sequence);

export function usePortfolioEntrance(ref) {
  const visible = useInView(ref, { once: true, amount: 0.2 });
  const { phase, setPhase } = usePortfolioSequence();
  useEffect(() => {
    if (visible && phase === "ready") setPhase("cards");
  }, [visible, phase, setPhase]);
  return {
    entered: ["cards", "stars", "done"].includes(phase),
    finishEntrance: () => setPhase(current => current === "cards" ? "stars" : current),
  };
}
